import { Injectable } from '@angular/core';

import { MainService } from './main.services';

import { environment } from '../../environments/environment';
import { jwtDecode } from 'jwt-decode';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MaterialService {
  constructor(
    private main: MainService
  ) {

   }

  capturedImage : string = "";
  croppedImage : string = "";

  getBoxData(id_camp : number,  id_dist : number): Observable<any>{
    return this.main.postRequest({ idDistribucion :  id_dist, idCampana : id_camp }, "/capturas-sucursal/box-data");
  }
  
  getVersionsData(id_camp : number, id_dist : number, id_grupo : number, capturedText? : string): Observable<any>{
    return this.main.postRequest({ idDistribucion :  id_dist, idCampana : id_camp, idGrupo : id_grupo, capturedText}, "/imagenes-versiones/versiones-data");
  }

  getComparedText(text1 : string, text2 : string): Observable<any>{
    return this.main.postRequest({ text1, text2 }, "/capturas-sucursal/compare-texts");
  }

  getMatData(id_camp_nest : number, id_camp_claw : number,  id_group : number): Observable<any>{
    return this.main.postRequest({ idCampanaNest :  id_camp_nest,  idCampanaClaw: id_camp_claw, idGroup : id_group}, "/materiales-sucursal/show");
  }

  getGroups(id:number){
    return this.main.getRequest("/materiales-sucursal/groups/"+id)
  }

  uploadMaterialImage(imgPayload : any): Observable<any>{
    return this.main.postRequestFormData(imgPayload, "/captura-inicial/capture-image");
  }

  saveMaterialImage(imgPayload : any): Observable<any>{
    return this.main.postRequestFormData(imgPayload, "/capturas-sucursal/capture-image");
  }

  getMaskUrl(url : string){
   return `${environment.apiUrl}/capturas-sucursal/proxy-image?url=${encodeURIComponent(url)}`;
  }

  omitGroup(id_camp : number,  id_dist : number, id_group : number, id_camp_nest : number): Observable<any>{
    return this.main.postRequest({ idDistribucion :  id_dist, idCampana : id_camp, idGrupo : id_group, idCampanaNest : id_camp_nest }, "/capturas-sucursal-omitidos/omit-by-group");
  }

  omitBox(id_camp : number,  id_dist : number, id_camp_nest : number): Observable<any>{
    return this.main.postRequest({ idDistribucion :  id_dist, idCampana : id_camp, idCampanaNest : id_camp_nest }, "/capturas-sucursal-omitidos/omit-by-box");
  }

  omitItem(id_camp : number,  id_dist : number, id_camp_nest : number, id_group : number, id_mat : number, version : number): Observable<any>{
    return this.main.postRequest({ idDistribucion :  id_dist, idCampana : id_camp, idCampanaNest : id_camp_nest, idGrupo : id_group , idMaterial : id_mat, version : version}, "/capturas-sucursal-omitidos/");
  }

}